var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h2',{staticClass:"mb-5"},[_vm._v(" "+_vm._s(_vm.begruessung)+_vm._s(_vm.anrede)+_vm._s(_vm.fullname)+" ")]),(_vm.$hasAnyRole(_vm.authUser, ['Admin', 'Arzt']))?_c('DashboardArzt',{attrs:{"user":_vm.authUser}}):_c('DashboardIgl')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }